module.exports = __webpack_public_path__ + "static/media/0323_IMG_TRAD_LES_MURS_BARDAGE_BOIS_HORIZONTAL.dd4f6b84.png";